module.exports = __webpack_public_path__ + "assets/img/image08.6c90c0fe.png";